var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"presence-badge"},[(_vm.presenceId)?_c('presence-thumbnail',{staticStyle:{"display":"inline"},attrs:{"presence-id":_vm.presenceId,"owner-id":_vm.ownerId,"size":"small"}}):_vm._e(),_c('span',{staticClass:"presence-name"},[_vm._v(" "+_vm._s(_vm.nameToShow)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }